<!-- 企业级-无人仓业务-出入库查询 -->
<template>
  <div class="mainArea CWareHoustQuery">
      
        <div class="searchDiv mt20">
          <div>
            <div class="dib mb10"><el-input placeholder="请输入订单号" v-model="keyword.order_id" clearable></el-input></div>
            <div class="dib mb10">
              <el-select v-model="keyword.type" clearable placeholder="请选择订单类型">
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="dib mb10">
              <el-select v-model="keyword.status" clearable placeholder="请选择回调状态">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="dib mb10">
              <el-select v-model="keyword.callback" clearable placeholder="请选择回调结果">
                <el-option
                  v-for="item in callList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="dib mb10"><el-input placeholder="请输入操作人手机号码" v-model="keyword.phone" clearable></el-input></div>
            <!-- <div class="dib mb10"><el-input placeholder="请输入操作人姓名" v-model="keyword.name" clearable></el-input></div> -->
            <el-button type="primary" @click="getStorageOrder(1)">搜索</el-button>
          </div>
        </div>
        <div class="tabList">
          <el-table :data="orderList" style="width: 100%" v-loading="tableLoading">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table :data="props.row.arrList" style="width: 100%" row-class-name="bgTable" header-cell-class-name="bgTable">
                  <!-- <el-table-column prop="" label="操作人姓名"></el-table-column> -->
                  <el-table-column prop="phone" label="操作人手机"></el-table-column>
                  <el-table-column prop="rent_time" label="进入仓库时间"></el-table-column>
                  <el-table-column prop="end_time" label="出来仓库时间"></el-table-column>
                  <el-table-column prop="locator" label="货位CODE"></el-table-column>
                  <el-table-column prop="location" label="子库"></el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column prop="boundOrder" label="订单号"></el-table-column>
            <el-table-column label="订单类型">
              <template slot-scope="scope">
                <span v-if="scope.row.order_state== '11'">入库</span>
                <span v-else>出库</span>
              </template>
            </el-table-column>
            <el-table-column prop="cabinet_id" label="设备ID"></el-table-column>
            <el-table-column label="具体RFID标签">
              <template slot-scope="scope">
                <el-button type="text" @click="openLook(scope.$index)">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column label="回调状态">
              <template slot-scope="scope">
                <span v-if="scope.row.is_send== '1'">已发送</span>
                <span v-else-if="scope.row.is_send== '2'">未发送</span>
                <span v-else-if="scope.row.is_send== '3'">发送失败</span>
                <span v-else>待确认</span>
              </template>
            </el-table-column>
            <el-table-column prop="retry_count" label="回调次数"></el-table-column>
            <el-table-column prop="result_desc" label="回调结果"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="repeatRfid(scope.$index)">重发</el-button>
                <el-button type="text" @click="openEdit(scope.$index)">修改状态</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="total>page">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="page"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      <!--查看RFID-->
      <el-dialog title="查看RFID" :visible.sync="lookRfidDio" width="800px">
        <el-table :data="rfidList" style="width: 100%" v-loading="tableLoading">
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column prop="sign" label="标识号"></el-table-column>
          <el-table-column prop="rfid" label="RFID"></el-table-column>
          <el-table-column prop="packageno" label="LPN"></el-table-column>
          <el-table-column prop="locator" label="位置"></el-table-column>
        </el-table>
      </el-dialog>

      <!--修改状态-->
      <el-dialog title="修改状态" :visible.sync="editDio" width="480px">
        <div class="contDio">
          <el-form ref="form" :model="editform" label-width="50px">
              <el-form-item label="状态:">
                <el-select v-model="editform.status" placeholder="请选择状态">
                  <el-option
                    v-for="item in statusList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="editStatus">确定</el-button>
          <el-button @click="editDio = false">取消</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../static/js/utility/utility.js"
  import { unmanApi } from "../../../../static/js/api.js"

  export default {
    name: 'CWareHoustQuery',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        keyword:{
          order_id:'',//订单号
          type:'',//类型
          status:'',//状态
          callback:'',//回调结果
          phone:'',//手机号
          name:'',//姓名
        },
        //类型列表
        typeList:[{
          id:'11',
          name:'入库'
        },{
          id:'100',
          name:'出库'
        }],
        //状态列表
        statusList:[{
          id:'1',
          name:'已发送'
        },{
          id:'2',
          name:'未发送'
        },{
          id:'8',
          name:'待确认'
        },{
          id:'3',
          name:'发送失败'
        }],
        //回调结果列表
        callList:[{
          id:'1',
          name:'回调成功'
        },{
          id:'2',
          name:'回调失败'
        }],


        orderList:[],//订单列表
        tableLoading:false,

        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        lookRfidDio:false,//查看rfid弹窗
        rfidList:[],

        editDio:false,//修改状态弹窗
        editform:{
          id:'',
          status:'',
        },
        
      };
    },
    mounted(){

    },
    created: async function () {
      this.getStorageOrder()
    },
    methods: {
      //修改状态
      async editStatus(){
        let that = this;
        const data = {
          'id':that.editform.id,//id
          'type': '2',//类型
          'status':that.editform.status,//状态
        }
        let res = await unmanApi.storageCallback(data)
        if(res.meta.code == 200){
          that.editDio = false;
          that.getStorageOrder()
          showToast('修改成功!')
        }else{
          showToast(res.meta.message)
        }
      },
      //打开修改状态
      openEdit(index){
        this.editform.id= this.orderList[index].id
        this.editform.status= this.orderList[index].is_send
        this.editDio = true;
      },
      //重发
      async repeatRfid(index){
        let that = this;
        const data = {
          'id':that.orderList[index].id,//id
          'type': '1',//类型
        }
        let res = await unmanApi.storageCallback(data)
        if(res.meta.code == 200){
          showToast('重发成功!')
        }else{
          showToast(res.meta.message)
        }
      },
      //查看RFID列表
      openLook(index){
        this.rfidList= this.orderList[index].signData
        this.lookRfidDio = true
      },
      //获取出入库列表
      async getStorageOrder(curr,limits){
        let that = this;
        this.tableLoading = true
        const data = {
          'page':curr ? curr : that.curr,//当前页
          'perPage': limits ? limits : that.page,//每页条数
          'phone': that.keyword.phone,//操作人电话字段搜索
          'boundOrder': that.keyword.order_id,//出入库订单搜索
          'order_state': that.keyword.type,//出入库字段搜索 入:11 出:100
          'is_send': that.keyword.status,//状态查询查询 1已发送 2未发送 3发送失败 8待确认
          'result': that.keyword.callback,//结果查询 1成功 2失败
        }
        let res = await unmanApi.getStorageOrder(data)
        if(res.meta.code == 200){
          for(let i in res.data.list){
            res.data.list[i].arrList=[]
            const obj = {}
            obj.phone = res.data.list[i].phone
            obj.rent_time = res.data.list[i].rent_time
            obj.end_time = res.data.list[i].end_time
            obj.locator = res.data.list[i].locator
            obj.location = res.data.list[i].location
            res.data.list[i].arrList.push(obj)
          }
          that.orderList = res.data.list
          that.total = parseInt(res.data.total)
          that.tableLoading = false
        }else{
          that.tableLoading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getStorageOrder(val)

      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      },
    }
  }
</script>

<style lang="scss">
.CWareHoustQuery{
  .dib{
    display:inline-block;
  }
  .el-table__expanded-cell{
    background: #f2f2f2;
    .bgTable{
      background: #f2f2f2;
    }
    &:hover{
      background-color: #f2f2f2 !important;
    }
    .el-table--enable-row-hover .el-table__body tr:hover>td{
      background-color: #f2f2f2;
    }
  }
  .contDio{
    .el-select{ display:block;}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CUnmanWarehouse/CWareHoustQuery.vue